import { userActions } from '@/core/state/user'
import { leaveToMarketingSite } from '@/react/router/leave'

/**
 * Sign out, then leave. App.vue did not wait: the user store clears its three
 * localStorage keys only after the logout POST returns, so a slow request left
 * the token behind and the next visit signed straight back in. The order is the
 * point, which is why it lives in a named function with its own test.
 */
export async function logoutAndLeave() {
  await userActions.logout()
  leaveToMarketingSite()
}
